<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 8px">Movement Orders</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="confirmData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="check"
                        >Confirm</vs-button
                    >
                    <vs-button
                        @click="cancelData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="cancel"
                        >Cancel</vs-button
                    >
                    <vs-button
                        @click="refreshData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                        >Refresh</vs-button
                    >
                    <vs-button
                        :to="{ name: 'movement-order-add' }"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="add"
                        >Add</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        icon="check"
                        @click="showMovementPopup"
                        >Assign Picker</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        icon="filter_list"
                        @click="filterInit"
                        >Filter</vs-button
                    >
                    <vs-button
                        @click="exportData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="import_export"
                        >Export</vs-button
                    >
                    <vs-button
                        @click="print"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="print"
                        >Print</vs-button
                    >
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more"
                            >Spreadsheets</vs-button
                        >
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="downloadTemplate()"
                                >Template</vs-dropdown-item
                            >
                            <vs-dropdown-item @click="showUploadInit"
                                >Upload</vs-dropdown-item
                            >
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <!-- <vs-button
                        @click="containerAdd = {show: true, movement_id: '', container_ids: [{no: 1, id: ''}], selected: []}"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="shopping_cart"
                    >Add To Container</vs-button> -->
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="movementOrders"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
            ></ag-grid-vue>
            <p class="text-right">
                <b
                    >Showing {{ dataFrom }} to {{ dataTo }} of
                    {{ dataTotal }} total entries</b
                >
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>
        </vx-card>
        <vs-prompt
            @accept="filterData"
            title="Filter"
            :active.sync="showFilter"
        >
            <div class="con-exemple-prompt">
                <label class="vs-input--label"
                    >Reference (Multi, separated by new line)</label
                >
                <vs-textarea height="50" v-model="filter.reference_multi" />

                <label class="vs-input--label">Client</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item
                        v-for="(item, index) in ddl_client.data"
                        :key="index"
                        :value="item.id"
                        :text="item.client_code"
                    />
                </vs-select>

                <label class="vs-input--label">Product ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.product_id"
                    width="100%"
                    autocomplete
                    multiple
                    @input-change="searchDropdown($event, product)"
                >
                    <vs-select-item
                        v-for="(item, index) in product.data"
                        :key="index"
                        :value="item.id"
                        :text="item.product_code"
                    />
                </vs-select>

                <label class="vs-input--label">Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.date_start"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.date_end"
                        />
                    </vs-col>
                </vs-row>

                <label class="vs-input--label">Status</label>
                <v-select
                    :options="statusOption"
                    v-model="filter.status_id"
                    :reduce="(option) => option.value"
                    :clearable="false"
                ></v-select>
            </div>
        </vs-prompt>
        <vs-popup
            title="Add Picklist to Container"
            :active.sync="containerAdd.show"
        >
            <div class="con-exemple-prompt">
                <vs-input
                    label="Picklist / Movement ID"
                    v-model="containerAdd.movement_id"
                    class="w-full mb-4"
                />
                <vs-table
                    v-model="containerAdd.selected"
                    :data="containerAdd.container_ids"
                    hoverFlat
                    multiple
                >
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">No</vs-th>
                        <vs-th>Container ID</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr
                            :data="tr"
                            :key="index"
                            v-for="(tr, index) in data"
                        >
                            <vs-td>
                                <vs-input
                                    class="w-full"
                                    :value="index + 1"
                                    disabled
                                />
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.id" />
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <vs-row class="flex justify-between mt-5">
                    <div>
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="flat"
                            @click="removeContainer"
                            :disabled="containerAdd.selected.length < 1"
                            >Remove Container</vs-button
                        >
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="filled"
                            @click="containerAdd.container_ids.push({ id: '' })"
                            >Add Container</vs-button
                        >
                    </div>
                    <div>
                        <vs-button
                            class="mr-4"
                            color="primary"
                            type="filled"
                            @click="addToContainer"
                            >Save</vs-button
                        >
                    </div>
                </vs-row>
            </div>
        </vs-popup>

        <vs-popup title="Assign Picker" :active.sync="showMovement">
            <div class="pb-5 row">
                <vs-table
                    stripe
                    multiple
                    :data="dataMovement"
                    v-model="selectedMovement"
                    hoverFlat
                    search
                >
                    <template slot="header">
                        <div class="mb-6 vx-row">
                            <div class="w-full vx-col md:w-1/3">
                                <span>Assign To</span>
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="picker_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="
                                        searchDropdown($event, pickers)
                                    "
                                >
                                    <vs-select-item
                                        v-for="(item, index) in pickers.data"
                                        :key="index"
                                        :value="item.id"
                                        :text="item.username"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </template>

                    <template slot="thead">
                        <vs-th></vs-th>
                        <vs-th sort-key="id">Movement ID</vs-th>
                        <vs-th sort-key="gr_id">GR ID</vs-th>
                        <vs-th sort-key="do_id">DO ID</vs-th>
                        <vs-th sort-key="qty_open">Open Qty</vs-th>
                        <vs-th sort-key="qty_confirmed">Confirmed Qty</vs-th>
                        <vs-th sort-key="qty_confirmed">Assign To</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr
                            :data="tr"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                        >
                            <vs-td :data="tr.id"> </vs-td>
                            <vs-td :data="data[indextr].id">
                                {{ data[indextr].id }}
                            </vs-td>

                            <vs-td :data="data[indextr].gr_id">
                                {{ data[indextr].gr_id }}
                            </vs-td>

                            <vs-td :data="data[indextr].do_id">
                                {{ data[indextr].do_id }}
                            </vs-td>

                            <vs-td :data="data[indextr].qty_open">
                                {{ data[indextr].qty_open }}
                            </vs-td>

                            <vs-td :data="data[indextr].qty_confirmed">
                                {{ data[indextr].qty_confirmed }}
                            </vs-td>
                            <vs-td :data="data[indextr].username">
                                {{ data[indextr].username }}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
                <vs-pagination
                    :total="totalPageMovs"
                    v-model="currentPageMov"
                    @input="fetchMovement"
                ></vs-pagination>
            </div>
            <div class="flex flex-wrap items-center justify-end mt-5">
                <div class="flex items-center">
                    <vs-button
                        class="mb-4 md:mb-0"
                        @click="savePicker"
                        color="primary"
                        >Save</vs-button
                    >
                </div>
            </div>
        </vs-popup>

        <vs-prompt
            @accept="uploadExcel"
            title="Upload Movement Order"
            :active.sync="showUpload"
        >
            <div class="con-exemple-prompt">
                <div class="w-1/3 vx-col">Auto Confirm</div>
                <div class="w-2/3 vx-col">
                    <vs-checkbox
                        v-model="uploadData.auto_confirm"
                    ></vs-checkbox>
                </div>

                <label class="vs-input--label"></label>
                <vs-upload
                    :showUploadButton="false"
                    :text="fileName"
                    ref="file_upload"
                />
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            containerAdd: {
                show: false,
                movement_id: "",
                container_ids: [
                    {
                        no: 1,
                        id: "",
                    },
                ],
                selected: [],
            },
            searchQuery: "",
            gridOptions: {},
            movementOrders: [],
            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            filter: {
                reference_multi: "",
                gr_reference: "",
                status_id: 4,
                client_id: null,
                date_start: null,
                date_end: null,
                product_id: [],
            },
            product: {
                data: [],
                loading: false,
                endpoint: "master/product",
                objectKey: "product_code",
            },
            ddl_client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
            statusOption: [
                {
                    value: 4,
                    label: "Any",
                },
                {
                    value: 1,
                    label: "Open",
                },
                {
                    value: 2,
                    label: "Confirmed",
                },
                {
                    value: 3,
                    label: "Cancelled",
                },
            ],
            totalPage: 0,
            currentPage: 1,
            currentPageMov: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            showMovement: false,
            picker_id: null,
            pickers: [],
            selectedMovement: [],
            dataMovement: [],
            totalPages: 0,
            totalPageMovs: 0,
            showUpload: false,
            fileName: "Select file (.xslx, .xls)",
            uploadData: {
                file: null,
                auto_confirm: false,
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function () {
            this.fetchData();
        },
    },
    methods: {
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post(
                    "inventories/movementorder?page=" + this.currentPage,
                    this.filter
                )
                .then((res) => {
                    this.movementOrders = res.data.data;
                    this.totalPage = res.data.last_page;
                    this.dataTotal = res.data.total;
                    this.dataFrom = res.data.from;
                    this.dataTo = res.data.to;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No",
                    });
                    return;
                });
        },

        exportData() {
            this.isLoading = true;

            const filterData = {
                status_id: this.filter.status_id,
            };

            this.$http
                .post(
                    "inventories/movementorder/report/download_excel",
                    this.filter,
                    {
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    this.isLoading = false;
                    FileSaver.saveAs(res.data, "mo_export.xlsx");
                });
            // .then(response => response.blob())
            // .then(blob => {
            // saveAs(blob, 'inbound_export.xlsx')
        },
        confirmData() {
            const selectedData = this.gridApi.getSelectedRows();
            if (selectedData.length <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected",
                });
            } else {
                this.isLoading = true;
                const dataSend = [];
                selectedData.map((item) => {
                    dataSend.push(item.id);
                });

                this.$http
                    .post("inventories/movementorder/confirm", { id: dataSend })
                    .then((res) => {
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: res.data.message || "Confirmed successfully",
                        });
                        this.refreshData();
                    })
                    .catch((error) => this.handleError(error));
            }
        },
        cancelData() {
            const selectedData = this.gridApi.getSelectedRows();
            if (selectedData.length <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected",
                });
            } else {
                this.isLoading = true;
                const dataSend = [];
                selectedData.map((item) => {
                    dataSend.push(item.id);
                });

                this.$http
                    .post("inventories/movementorder/cancel", { id: dataSend })
                    .then((res) => {
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: res.data.message || "Canceled successfully",
                        });
                        this.refreshData();
                    })
                    .catch((error) => this.handleError(error));
            }
        },
        filterData() {
            this.fetchData();
        },
        filterInit() {
            this.showFilter = true;
        },
        addToContainer() {
            let error = false;
            let ids = [];

            if (!this.containerAdd.movement_id) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: `Movement ID is empty`,
                });

                error = true;
            }

            this.containerAdd.container_ids.map((item, index) => {
                if (!item.id) {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: `Line ${index + 1} - Empty container ID`,
                    });

                    error = true;
                }
            });

            if (error) {
                return false;
            }

            const data = {
                movement_id: this.containerAdd.movement_id,
                container_ids: this.containerAdd.container_ids.map(
                    (item) => item.id
                ),
            };

            this.isLoading = true;
            this.$http
                .post("inventories/movementorder/addtocontainer", data)
                .then((res) => {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: `Added picklist ${data.movement_id} to ${data.container_ids.length} container`,
                    });

                    this.containerAdd.show = false;
                    this.isLoading = false;
                })
                .catch((error) => this.handleError(error));
        },
        removeContainer() {
            let indexes = [];
            this.containerAdd.container_ids.map((item, index) => {
                item.no = index + 1;
            });

            this.containerAdd.selected.map((selected) => {
                this.containerAdd.container_ids.map((container, index) => {
                    if (selected.no == container.no) {
                        indexes.push(index);
                    }
                });
            });

            this.containerAdd.selected = [];

            indexes.sort((a, b) => b - a);
            indexes.map((i) => {
                this.containerAdd.container_ids.splice(i, 1);
            });
        },
        print() {
            const selectedData = this.gridApi.getSelectedRows();
            if (selectedData.length <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected",
                });
            } else {
                this.isLoading = true;
                const dataSend = [];
                selectedData.map((item) => {
                    dataSend.push(item.movement_id);
                });

                this.$http
                    .post(
                        "inventories/movementorder/print",
                        { id: dataSend },
                        { responseType: "blob" }
                    )
                    .then((res) => {
                        this.isLoading = false;
                        var blob = new Blob([res.data], {
                            type: "application/pdf",
                        });
                        window.open(URL.createObjectURL(blob));
                    })
                    .catch((error) => this.handleError(error));
            }
        },
        showMovementPopup() {
            this.selectedMovement = [];
            this.isLoading = true;

            this.$http
                .post(
                    "inventories/movementorder/list_movement?page=" +
                        this.currentPageMov
                )
                .then((resp) => {
                    this.dataMovement = resp.data.data;
                    this.totalPageMovs = resp.data.last_page;
                    this.currentPageMov = this.currentPageMov;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;

                    setTimeout(() => {
                        this.isLoading = false;
                        this.showMovement = true;
                    }, 500);
                })
                .catch((resp) => {
                    this.isLoading = false;
                    console.log(resp);
                });
        },
        fetchMovement() {
            this.isLoading = true;

            this.$http
                .post(
                    "inventories/movementorder/list_movement?page=" +
                        this.currentPageMov
                )
                .then((resp) => {
                    this.dataMovement = resp.data.data;
                    this.totalPageMovs = resp.data.last_page;
                    this.currentPageMov = this.currentPageMov;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                })
                .catch((resp) => {
                    this.isLoading = false;
                    console.log(resp);
                });
        },
        fetchPicker() {
            Promise.all([this.$http.post("rolemanagement/users")])
                .then(
                    this.$http.spread((user) => {
                        this.pickers.data = user.data.data;
                        this.$vs.loading.close();
                    })
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.fetchPicker();
                        },
                        cancel: () =>
                            this.$router.push({ name: "movement-order" }),
                        acceptText: "Yes",
                        cancelText: "No",
                    });
                });
        },
        savePicker() {
            if (this.selectedMovement.length <= 0) {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "No data selected",
                });
            } else {
                this.isLoading = true;
                const dataSendMovement = [];
                this.selectedMovement.map((item) => {
                    dataSendMovement.push(item.id);
                });

                this.$http
                    .post("inventories/movementorder/assign_picker", {
                        movement: dataSendMovement,
                        picker: this.picker_id,
                    })
                    .then((res) => {
                        this.isLoading = false;
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: res.data.message || "Confirmed successfully",
                        });
                        this.showMovement = false;
                    })
                    .catch((error) => this.handleError(error));
            }
        },
        downloadTemplate() {
            this.isLoading = true;
            const endpoint = "inventories/movementorder/get_template";
            this.$http
                .get(endpoint, { responseType: "blob" })
                .then((response) => {
                    var blob = new Blob([response.data]);
                    saveAs(blob, `movement_template_${Date.now()}.xlsx`);
                    this.isLoading = false;
                });
        },
        uploadExcel() {
            let form = new FormData();
            form.append("file", this.uploadData.file);
            this.isLoading = true;
            this.$http
                .post("/inventories/movementorder/uploadexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        auto_confirm: this.uploadData.auto_confirm,
                    },
                })
                .then((resp) => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Successfully",
                    });
                })
                .catch((error) => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        showUploadInit() {
            this.isLoading = true;
            this.uploadData.file = null;
            this.resetUploadForm();
            this.showUpload = true;

            setTimeout(() => {
                this.$watch(
                    () => {
                        return this.$refs.file_upload.filesx[0];
                    },
                    (val) => {
                        this.getSelectedFile();
                    }
                );

                this.isLoading = false;
            }, 100);
        },
        getSelectedFile() {
            const files = this.$refs.file_upload.filesx;

            if (files.length > 1) {
                files.splice(0, 1);
            }

            const file = files[0];

            if (file) {
                const filetype = file.type;
                if (
                    filetype !==
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                    filetype !== "application/vnd.ms-excel"
                ) {
                    files.splice(0, 1);
                    this.uploadData.file = null;

                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "Invalid file format",
                    });
                } else {
                    this.uploadData.file = file;
                    this.fileName = file.name;
                }
            }
        },
        resetUploadForm() {
            this.fileName = "Select file (.xslx, .xls)";
        },
    },
    mounted() {
        this.showFilter = true;
        this.gridApi = this.gridOptions.api;
        this.fetchPicker();
        this.$vs.loading.close();
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Movement ID",
                field: "movement_id",
                width: 120,
                checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                headerCheckboxSelection: true,
            },
            {
                headerName: "Movement Date",
                field: "movement_date",
                width: 120,
            },
            {
                headerName: "Transaction Source",
                field: "transaction_source",
                width: 120,
            },
            {
                headerName: "Reference",
                field: "reference",
                width: 120,
                // pinned: 'left'
            },
            {
                headerName: "Client ID",
                width: 120,
                field: "client_code",
            },
            {
                headerName: "Warehouse ID",
                field: "warehouse.warehouses_code",
                width: 120,
            },
            {
                headerName: "Product ID",
                field: "product_code",
                width: 120,
            },
            {
                headerName: "Description",
                field: "description",
                width: 120,
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 120,
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 120,
            },
            {
                headerName: "Exp. Date",
                field: "expired_date",
                width: 120,
            },
            {
                headerName: "Base Qty",
                field: "base_qty",
                width: 120,
            },
            {
                headerName: "Base UoM",
                field: "base_uom_name",
                width: 120,
            },
            {
                headerName: "Stock Type",
                field: "stock_type_name",
                width: 120,
            },
            {
                headerName: "Src. Location Type",
                field: "source_location_type",
                width: 120,
            },
            {
                headerName: "Src. Location ID",
                width: 120,
                cellRenderer: (params) => {
                    if (params.data.source_location_code) {
                        return params.data.source_location_code;
                    } else {
                        return params.data.source_location_id;
                    }
                },
            },
            {
                headerName: "Src. Storage Unit",
                field: "source_storage_unit",
                width: 120,
            },
            {
                headerName: "Dest. Location Type",
                field: "dest_location_type",
                width: 120,
            },
            {
                headerName: "Dest. Location ID",
                field: "dest_location_code",
                width: 120,
            },
            {
                headerName: "Dest. Storage Unit",
                field: "dest_storage_unit",
                width: 120,
            },
            {
                headerName: "Status",
                field: "status_name",
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function (params) {
            return 35;
        };
    },
};
</script>
